<fm-balloon
  *ngIf="balloon"
  [ngClass]="balloon?.marker.type === EPlotType.replay"
  [@balloonAnimation]="animationState"
  [balloon]="balloon"
  [contentTemplate]="balloonTemplate"
  [showSpike]="false"
  (closed)="onBalloonClosed()"
></fm-balloon>
